<template>
  <div class="account bcel">
    <img
      v-if="account.bankCode === 'BCEL'"
      src="@/assets/images/bcel.png"
      @click="isImageBcelModalActive = true"
    />
    <div class="columns is-mobile">
      <div class="column is-3 is-one-third-mobile">
        <div class="order">1</div>
      </div>
      <div class="column is-9 is-two-third-mobile">
        <div class="bank-detail">
          <div class="bank-name-th">
            {{ depositAccount.bank.nameTH }}
          </div>
          <div class="bank-name-en">
            {{ depositAccount.bank.nameEN }}
          </div>
          <div class="account-name m-t-10">
            {{ depositAccount.bankAccountName }}
          </div>
          <div class="account-no">
            {{ depositAccount.currency }} :
            {{ depositAccount.bankAccountNo | bankAccountFormat }}
            <i
              class="fas fa-copy m-l-10"
              v-clipboard:copy="depositAccount.bankAccountNo"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <b-modal :active.sync="isImageBcelModalActive">
      <p class="image full-screen">
        <img src="@/assets/images/bcel.png" />
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalDeposit',
  props: {
    depositAccount: {
      type: Object
    },
    account: {
      type: Object
    }
  },
  data() {
    return {
      isImageBcelModalActive: false
    }
  },
  methods: {
    onCopy(e) {
      this.$buefy.toast.open({
        message: `Copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    }
  }
}
</script>
